import defaultValues from '../lib/defaultValues.js'
import GooglePlaces from '../../lib/googlePlacesApi.js'

const state = {
  userType: defaultValues.userType,
  legalFirstName: defaultValues.userLegalFirstName,
  lastName: defaultValues.userLastName,
  email: defaultValues.userEmail,
  cellPhone: defaultValues.userCellPhone,
  street1: defaultValues.userStreet1,
  street2: defaultValues.userStreet2,
  city: defaultValues.userCity,
  state: defaultValues.userState,
  zipCode: defaultValues.userZipCode,
  images: JSON.parse(JSON.stringify(defaultValues.userImages)),
  profileImage: defaultValues.userProfileImage,
  couponAlerts: JSON.parse(JSON.stringify(defaultValues.userCouponAlerts)),
  promotionAlerts: JSON.parse(JSON.stringify(defaultValues.userPromotionAlerts)),
  savedBusinesses: JSON.parse(JSON.stringify(defaultValues.userSavedBusinesses)),
  savedHouses: JSON.parse(JSON.stringify(defaultValues.userSavedHouses)),
  claimedHouses: JSON.parse(JSON.stringify(defaultValues.userClaimedHouses)),
  myRealtorCode: defaultValues.userMyRealtorCode,
  myServiceProviderId: defaultValues.userMyServiceProviderId,
  blockList: JSON.parse(JSON.stringify(defaultValues.blockList)),
  notificationNumber: defaultValues.notificationNumber
}

const getters = {
  getBlockList: (state) => {
    return state.blockList
  },
  getNotificationNumber: (state) => {
    return state.notificationNumber
  },
  getUserType: (state) => {
    return state.userType
  },
  getLegalFirstName: (state) => {
    return state.legalFirstName
  },
  getLastName: (state) => {
    return state.lastName
  },
  getEmail: (state) => {
    return state.email
  },
  getCellPhone: (state) => {
    return state.cellPhone
  },
  getStreet1: (state) => {
    return state.street1
  },
  getStreet2: (state) => {
    return state.street2
  },
  getCity: (state) => {
    return state.city
  },
  getState: (state) => {
    return state.state
  },
  getZipCode: (state) => {
    return state.zipCode
  },
  getImages: (state) => {
    return state.images
  },
  getProfileImage: (state) => {
    return state.profileImage
  },
  getCouponAlerts: (state) => {
    return state.couponAlerts
  },
  getPromotionAlerts: (state) => {
    return state.promotionAlerts
  },
  getImageUrls (state, getters, rootGetters) {
    var imageURLS = []
    var baseURL = 'https://s3.' + window.CONFIG.Region + '.amazonaws.com/' + window.CONFIG.PhotoBucketName + '/xsmall/'
    if (rootGetters.cognitoId) {
      var cognitoId = rootGetters.cognitoId.split(':')[1]
    }
    for (var image in state.images) {
      var imageURL = baseURL + cognitoId + '/' + state.images[image]
      imageURLS.push(imageURL)
    }
    return imageURLS
  },
  getProfileImageUrl (state, getters, rootGetters) {
    var baseURL = 'https://s3.' + window.CONFIG.Region + '.amazonaws.com/' + window.CONFIG.PhotoBucketName + '/xsmall/'
    if (rootGetters.cognitoId) {
      var cognitoId = rootGetters.cognitoId.split(':')[1]
    }
    return baseURL + cognitoId + '/' + getters.getProfileImage
  },
  getSavedBusinesses: (state) => {
    return state.savedBusinesses
  },
  getSavedHouses: (state) => {
    return state.savedHouses
  },
  getClaimedHouses: (state) => {
    return state.claimedHouses
  },
  getMyRealtorCode: (state) => {
    return state.myRealtorCode
  },
  getMyServiceProviderId: (state) => {
    return state.myServiceProviderId
  }
}

const mutations = {
  addToBlockList: (state, id) => {
    if (!state.blockList.includes(id)) {
      state.blockList.push(id)
    }
  },
  removeFromBlockList: (state, id) => {
    var index = state.blockList.indexOf(id)
    if (index > -1) {
      state.blockList.splice(index, 1)
    }
  },
  updateBlockList: (state, blockList) => {
    state.blockList = blockList
  },
  updateNotificationNumber: (state, notificationNumber) => {
    state.notificationNumber = notificationNumber
  },
  updateUserType: (state, userType) => {
    state.userType = userType
  },
  updateLegalFirstName: (state, legalFirstName) => {
    state.legalFirstName = legalFirstName
  },
  updateLastName: (state, lastName) => {
    state.lastName = lastName
  },
  updateEmail: (state, email) => {
    state.email = email
  },
  updateCellPhone: (state, cellPhone) => {
    state.cellPhone = cellPhone
  },
  updateStreet1: (state, street1) => {
    state.street1 = street1
  },
  updateStreet2: (state, street2) => {
    state.street2 = street2
  },
  updateCity: (state, city) => {
    state.city = city
  },
  updateState: (state, usState) => {
    state.state = usState
  },
  updateZipCode: (state, zipCode) => {
    state.zipCode = zipCode
  },
  updateImages: (state, images) => {
    state.images = images
  },
  removeImage: (state, image) => {
    var index = state.images.indexOf(image)
    var profileIndex = state.images.indexOf(state.profileImage)
    if (index > -1) state.images.splice(index, 1)
    if (profileIndex === index) state.profileImage = null
  },
  updateProfileImage: (state, profileImage) => {
    state.profileImage = profileImage
  },
  updateCouponAlerts: (state, couponAlerts) => {
    state.couponAlerts = couponAlerts
  },
  updatePromotionAlerts: (state, promotionAlerts) => {
    state.promotionAlerts = promotionAlerts
  },
  updateSavedBusinesses: (state, savedBusinesses) => {
    state.savedBusinesses = savedBusinesses
  },
  addSavedBusiness: (state, savedBusiness) => {
    if (!state.savedBusinesses.includes(savedBusiness)) {
      state.savedBusinesses.push(savedBusiness)
    }
  },
  removeSavedBusiness: (state, savedBusiness) => {
    var index = state.savedBusinesses.indexOf(savedBusiness)
    if (index > -1) {
      state.savedBusinesses.splice(index, 1)
    }
  },
  updateSavedHouses: (state, savedHouses) => {
    state.savedHouses = savedHouses
  },
  addSavedHouse: (state, savedHouse) => {
    if (!state.savedHouses.includes(savedHouse)) {
      state.savedHouses.push(savedHouse)
    }
  },
  removeSavedHouse: (state, savedHouse) => {
    var index = state.savedHouses.indexOf(savedHouse)
    if (index > -1) {
      state.savedHouses.splice(index, 1)
    }
  },
  updateClaimedHouses: (state, claimedHouses) => {
    state.claimedHouses = claimedHouses
  },
  addClaimedHouse: (state, claimedHouse) => {
    if (!state.claimedHouses.includes(claimedHouse)) {
      state.claimedHouses.push(claimedHouse)
    }
  },
  removeClaimedHouse: (state, claimedHouse) => {
    var index = state.claimedHouses.indexOf(claimedHouse)
    if (index > -1) {
      state.claimedHouses.splice(index, 1)
    }
  },
  updateMyRealtorCode: (state, myRealtorCode) => {
    state.myRealtorCode = myRealtorCode
  },
  updateMyServiceProviderId: (state, myServiceProviderId) => {
    state.myServiceProviderId = myServiceProviderId
  }
}

const actions = {
  async getSavedBusinessData ({ commit, state, rootGetters }, args) {
    if (state.userType !== 'user') return
    if (!Number.isInteger(args.start) || !Number.isInteger(args.stop)) return
    var businessesToGet = state.savedBusinesses.slice(args.start, args.stop)
    var client = rootGetters.getBusinessApigClientFactory
    var params = {}
    var pathTemplate = '/batchgetbusinesses'
    var method = 'POST'
    var additionalParams = {}
    var body = {
      business_ids: businessesToGet
    }
    try {
      var homAptResults = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
      var homAptBusinessIds = homAptResults.data.map((result) => result.business_id)
      var googleBusinessIds = businessesToGet.filter((id) => !homAptBusinessIds.includes(id))
      var googleResults = await Promise.all(googleBusinessIds.map((savedBusiness) => {
        if (!homAptBusinessIds.includes(savedBusiness)) return GooglePlaces.googleDetails(args.node, savedBusiness)
      }))
      for (var i = 0; i < googleResults.length; i++) {
        googleResults[i].businessId = googleBusinessIds[i]
      }
      var homAptCardData = homAptResults.data.reduce((cardData, businessData) => {
        cardData.push({
          availabilityLevel: businessData.availability_level.toString(),
          businessId: businessData.business_id,
          costLevel: businessData.cost_level.toString(),
          emergencies: businessData.emergencies,
          google: false,
          profileImage: businessData.profile_image,
          title: businessData.display_name
        })
        return cardData
      }, [])
      var googleCardData = googleResults.reduce((cardData, businessData) => {
        cardData.push({
          businessId: businessData.businessId,
          title: businessData.name,
          rating: Math.round(businessData.rating * 10) / 10,
          google: true
        })
        return cardData
      }, [])
      return [...homAptCardData, ...googleCardData]
    } catch (error) {
      console.log(error)
    }
  },
  async getNotifications ({ commit, state, rootGetters }) {
    if (!state.userType) return
    var client = rootGetters.getNotificationApigClientFactory
    var params = {}
    var pathTemplate = '/notifications'
    var method = 'GET'
    var additionalParams = {
      queryParams: {
        limit: 25
      }
    }
    if (state.userType === 'business') additionalParams.queryParams['requesting_as'] = rootGetters['business/getBusinessId']
    var body = {}
    try {
      var notificationData = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
      if (notificationData.data.data.length > 0) {
        for (var record of notificationData.data.data) {
          console.log('Individual record: ' + record.toString())
          if (record.category === 'Unread Messages') {
            console.log('Updating unread count')
            commit('updateNotificationNumber', record.unread_count)
          }
        }
      } else {
        state.notificationNumber = 0
      }
    } catch (error) {
      console.log(error)
    }
  },
  async putUserData ({ commit, state, rootGetters }) {
    var client = rootGetters.getUserApigClientFactory
    var params = {}
    var pathTemplate = '/users'
    var method = 'PUT'
    var additionalParams = {}
    var body = {
      'current_user_type': state.userType,
      'legal_first_name': state.legalFirstName,
      'last_name': state.lastName,
      'email': state.email,
      'cell_phone': state.cellPhone,
      'street1': state.street1,
      'street2': state.street2,
      'city': state.city,
      'state': state.state,
      'zip_code': state.zipCode,
      'images': state.images,
      'profile_image': state.profileImage,
      'coupon_alerts': JSON.stringify(state.couponAlerts),
      'promotion_alerts': JSON.stringify(state.promotionAlerts),
      'saved_businesses': state.savedBusinesses,
      'saved_houses': state.savedHouses,
      'claimed_homes': state.claimedHouses,
      'my_realtor_code': state.myRealtorCode,
      'my_service_provider_id': state.myServiceProviderId,
      'block_list': state.blockList
    }
    return client.invokeApi(params, pathTemplate, method, additionalParams, body)
  },
  async getCurrentUserData ({ commit, state, rootGetters }) {
    var client = rootGetters.getUserApigClientFactory
    var params = {}
    var pathTemplate = '/users'
    var method = 'GET'
    var additionalParams = {}
    var body = {}
    try {
      var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
      if ('current_user_type' in result.data) commit('updateUserType', result.data.current_user_type)
      if ('legal_first_name' in result.data) commit('updateLegalFirstName', result.data.legal_first_name)
      if ('last_name' in result.data) commit('updateLastName', result.data.last_name)
      if ('email' in result.data) commit('updateEmail', result.data.email)
      if ('cell_phone' in result.data) commit('updateCellPhone', result.data.cell_phone)
      if ('street1' in result.data) commit('updateStreet1', result.data.street1)
      if ('street2' in result.data) commit('updateStreet2', result.data.street2)
      if ('city' in result.data) commit('updateCity', result.data.city)
      if ('state' in result.data) commit('updateState', result.data.state)
      if ('zip_code' in result.data) commit('updateZipCode', result.data.zip_code)
      if ('images' in result.data) commit('updateImages', result.data.images)
      if ('profile_image' in result.data) commit('updateProfileImage', result.data.profile_image)
      if ('coupon_alerts' in result.data) commit('updateCouponAlerts', JSON.parse(result.data.coupon_alerts))
      if ('promotion_alerts' in result.data) commit('updatePromotionAlerts', JSON.parse(result.data.promotion_alerts))
      if ('saved_businesses' in result.data) commit('updateSavedBusinesses', result.data.saved_businesses)
      if ('saved_houses' in result.data) commit('updateSavedHouses', result.data.saved_houses)
      if ('claimed_homes' in result.data) commit('updateClaimedHouses', result.data.claimed_homes)
      if ('my_realtor_code' in result.data) commit('updateMyRealtorCode', result.data.my_realtor_code)
      if ('my_service_provider_id' in result.data) commit('updateMyServiceProviderId', result.data.my_service_provider_id)
      if ('block_list' in result.data) commit('updateBlockList', result.data.block_list)
    } catch (error) {
      console.log(error)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js